import { DatePicker, ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { Button, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Skeleton } from '@mui/material';
import moment from 'moment';
import React from 'react';
import useStyles from './styles';
const LABEL = 'Charge on date';
const FIELD_WIDTH = 220;
// Apply Billing's words for the same field, so both screens explain it alike.
const HELP = "Set the date to post the charge or credit — if you leave it blank, we’ll use date from property settings. If it's not set - we’ll use today’s date.";
const formatDate = value => value ? moment(value).format('MM/DD/YYYY') : '';

/**
 * The AppFolio charge on date of one allocation table (LB-6118, requested by Haley), as Apply Billing shows it: the
 * table's own date when one was picked, the default otherwise, × to go back to the default, and ? to say what it does.
 * Read-only where the date can no longer change.
 */
export function ChargeOnDateField(_ref) {
  let chargeOn = _ref.chargeOn;
  const classes = useStyles();
  const defaultDate = chargeOn.defaultDate,
    _chargeOn$id = chargeOn.id,
    id = _chargeOn$id === void 0 ? 'chargeOnDate' : _chargeOn$id,
    isLoading = chargeOn.isLoading,
    isLocked = chargeOn.isLocked,
    isSaving = chargeOn.isSaving,
    isWaitingForAllocation = chargeOn.isWaitingForAllocation,
    onChange = chargeOn.onChange,
    value = chargeOn.value;
  const shown = value !== null && value !== void 0 ? value : defaultDate;
  const renderField = () => {
    if (isLoading) return /*#__PURE__*/React.createElement(Skeleton, {
      animation: "wave",
      height: 40,
      variant: "rectangular",
      width: FIELD_WIDTH
    });

    // The DatePicker takes no `disabled`, so a date that can't change is shown in a disabled input, as Apply Billing does.
    if (isLocked || isSaving) {
      return /*#__PURE__*/React.createElement(FormControl, {
        style: {
          width: FIELD_WIDTH
        },
        variant: "outlined"
      }, /*#__PURE__*/React.createElement(InputLabel, {
        htmlFor: id
      }, LABEL), /*#__PURE__*/React.createElement(OutlinedInput, {
        disabled: true,
        endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
          position: "start"
        }, /*#__PURE__*/React.createElement(Icon, {
          state: "lightGrey",
          type: "calendar-picker"
        })),
        id: id,
        label: LABEL,
        type: "text",
        value: formatDate(shown)
      }));
    }
    return /*#__PURE__*/React.createElement(ExpandedTooltip, {
      placement: "top",
      title: value || !defaultDate ? '' : "Charge on date will be set to ".concat(formatDate(defaultDate)),
      type: "success-bold-dark"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        width: FIELD_WIDTH
      }
    }, /*#__PURE__*/React.createElement(DatePicker, {
      format: "MM/dd/yyyy",
      label: value || !defaultDate ? LABEL : formatDate(defaultDate),
      onChange: date => onChange(date),
      value: value ? moment(value).toDate() : null
    })));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.chargeOn
  }, renderField(), /*#__PURE__*/React.createElement(Button, {
    "aria-label": "Use the default charge on date",
    className: classes.chargeOnClear,
    disabled: isLocked || isSaving || isLoading || !value,
    onClick: () => onChange(null),
    variant: "actionButtonInvert"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  })), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: HELP,
    type: "grey"
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "About the charge on date"
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  }))), isWaitingForAllocation ? /*#__PURE__*/React.createElement("span", {
    className: classes.chargeOnNote
  }, "Saved when this table is allocated.") : null);
}